import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminShell from './components/AdminShell';
import ProtectedRoute from './components/ProtectedRoute';
import { AdminPortalProvider } from './context/AdminPortalContext';
import AuditPage from './pages/AuditPage';
import BillingPage from './pages/BillingPage';
import ClubsAdminPage from './pages/ClubsAdminPage';
import ConfigPage from './pages/ConfigPage';
import IncidentsPage from './pages/IncidentsPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import OverviewPage from './pages/OverviewPage';
import OwnersPage from './pages/OwnersPage';
import PlayersPage from './pages/PlayersPage';
import RealtimePage from './pages/RealtimePage';
import SecurityPage from './pages/SecurityPage';
import SystemPage from './pages/SystemPage';
import GameModesConfigPage from './pages/GameModesConfigPage';
import AnnouncementsPage from './pages/AnnouncementsPage';

const App: React.FC = () => {
  return (
    <AdminPortalProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="overview" element={<OverviewPage />} />
          <Route path="clubs" element={<ClubsAdminPage />} />
          <Route path="owners" element={<OwnersPage />} />
          <Route path="players" element={<PlayersPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="realtime" element={<RealtimePage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="system" element={<SystemPage />} />
          <Route path="incidents" element={<IncidentsPage />} />
          <Route path="config" element={<ConfigPage />} />
          <Route path="game-modes" element={<GameModesConfigPage />} />
          <Route path="announcements" element={<AnnouncementsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AdminPortalProvider>
  );
};

export default App;
